export default __webpack_public_path__ + "8ef3a0b56e429133411ee00e2cf651a5.jpg";